import React from 'react';
export var CheckMark = function CheckMark(_ref) {
  var _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 1.5 : _ref$strokeWidth;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6127 4.44467L5.83456 12.2228L1.38989 7.77817",
    fill: "none",
    stroke: "inherit",
    strokeWidth: strokeWidth
  }));
};